// services/apiConfig.js
// Single source of truth for URLs used by the landing website, the admin panel and the company / facility portal.

// REACT_APP_API_URL is the API root, e.g. https://example.com/ServiceBooking/api
// (an old value ending in /admin or /company is accepted too and normalised).
export const API_ROOT = (process.env.REACT_APP_API_URL || '')
  .replace(/\/+$/, '')
  .replace(/\/(admin|company)$/, '');

export const ADMIN_API_URL = `${API_ROOT}/admin`;
export const COMPANY_API_URL = `${API_ROOT}/company`;

// One build, three sites under the app root ("homepage" in package.json, "/" in production):
//   landing website  → <root>/...
//   admin panel      → <root>/admin/...
//   facility portal  → <root>/facility/...
// Each page load picks its site from the URL and mounts that site's routes with the site's
// basename, so in-app links stay short ("/dashboard" → <root>/admin/dashboard).
const APP_ROOT = (process.env.PUBLIC_URL || '').replace(/\/+$/, '');
export const WEBSITE_BASE = APP_ROOT;
export const ADMIN_BASE = APP_ROOT + '/admin';
export const FACILITY_BASE = APP_ROOT + '/facility';

const isUnder = (base) => window.location.pathname === base
  || window.location.pathname.startsWith(base + '/');

// 'admin' | 'facility' | 'website' — matches meta.site in router/routes.js
export const CURRENT_SITE = isUnder(ADMIN_BASE) ? 'admin'
  : isUnder(FACILITY_BASE) ? 'facility'
  : 'website';

// Router basename for the current site
export const BASE_PATH = { admin: ADMIN_BASE, facility: FACILITY_BASE, website: WEBSITE_BASE }[CURRENT_SITE];

// Absolute URLs, for full-page redirects and links across the sites
export const ADMIN_LOGIN_URL = `${ADMIN_BASE}/login`;
export const ADMIN_HOME_URL = `${ADMIN_BASE}/dashboard`;
export const FACILITY_LOGIN_URL = `${FACILITY_BASE}/login`;
export const FACILITY_HOME_URL = `${FACILITY_BASE}/dashboard`;
